export const STRIP_WIDTH_MIN = 160;
export const STRIP_WIDTH_MAX = 360;
export const STRIP_WIDTH_DEFAULT = 200;
export const STRIP_WIDTH_STORAGE_KEY = 'athena.presentations.slideStripWidth';

export function clampStripWidth(width: number): number {
  if (!Number.isFinite(width)) return STRIP_WIDTH_DEFAULT;
  return Math.max(STRIP_WIDTH_MIN, Math.min(STRIP_WIDTH_MAX, Math.round(width)));
}

export function readStoredStripWidth(): number {
  if (typeof window === 'undefined') return STRIP_WIDTH_DEFAULT;
  const raw = Number(window.localStorage.getItem(STRIP_WIDTH_STORAGE_KEY));
  return clampStripWidth(Number.isFinite(raw) && raw > 0 ? raw : STRIP_WIDTH_DEFAULT);
}

export function writeStoredStripWidth(width: number): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STRIP_WIDTH_STORAGE_KEY, String(clampStripWidth(width)));
}

export function moveSlideId(ids: string[], sourceId: string, targetId: string): string[] {
  if (sourceId === targetId) return ids.slice();
  const from = ids.indexOf(sourceId);
  const to = ids.indexOf(targetId);
  if (from < 0 || to < 0) return ids.slice();
  const next = ids.slice();
  next.splice(from, 1);
  next.splice(to, 0, sourceId);
  return next;
}

export function moveSlideByOffset(ids: string[], sourceId: string, offset: -1 | 1): string[] {
  const from = ids.indexOf(sourceId);
  if (from < 0) return ids.slice();
  const to = from + offset;
  if (to < 0 || to >= ids.length) return ids.slice();
  return moveSlideId(ids, sourceId, ids[to]);
}

export function applySlideOrders<T extends { slideId: string; order: number }>(slides: T[], ids: string[]): T[] {
  const map = new Map(slides.map((slide) => [slide.slideId, slide]));
  return ids.flatMap((id, order) => {
    const slide = map.get(id);
    return slide ? [{ ...slide, order }] : [];
  });
}

export function visibleSlides<T extends { hidden?: boolean }>(slides: T[]): T[] {
  return slides.filter((slide) => !slide.hidden);
}

export function presenterStartIndex<T extends { slideId: string; hidden?: boolean }>(
  slides: T[],
  activeSlideId: string | null,
): number {
  const visible = visibleSlides(slides);
  if (!visible.length) return 0;
  const index = visible.findIndex((slide) => slide.slideId === activeSlideId);
  return index >= 0 ? index : 0;
}
